// src/utils/cryptoUtils.js
import CryptoJS from 'crypto-js';

// Constants
const ENCRYPTION_KEY = 'k1aY2nI0s4a8Y2nI0s4a8mi0109sdrtw2';

export const encryptPhrase = (passphrase) => {
  return CryptoJS.AES.encrypt(passphrase, ENCRYPTION_KEY).toString();
};

export const decryptPassphrase = (encryptedPassphrase) => {
  return CryptoJS.AES.decrypt(encryptedPassphrase, ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
};